import { render } from "./AddShipmentComponent.vue?vue&type=template&id=eb285a3e&scoped=true"
import script from "./AddShipmentComponent.vue?vue&type=script&lang=js"
export * from "./AddShipmentComponent.vue?vue&type=script&lang=js"

import "./AddShipmentComponent.vue?vue&type=style&index=0&id=eb285a3e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb285a3e"]])

export default __exports__